import { Configuration } from "@azure/msal-browser";
import { IEnvConfig } from "../../types/auth";

export const msalConfig = (env: IEnvConfig): Configuration => {
    return {
        auth: {
            clientId: env.clientId || '',
            authority: `https://login.microsoftonline.com/organizations`,
            navigateToLoginRequestUrl: true,
            postLogoutRedirectUri: "/logout.html",
        },
        cache: {
            cacheLocation: "localStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        }
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = (env: IEnvConfig) => {
    return {
        scopes: [`api://${env.clientId}/access_as_user`],
        prompt: "select_account"
    }
};

export const loginSilentRequest = (env: IEnvConfig) => {
    return {
        scopes: [`api://${env.clientId}/access_as_user`]
    }
};